export default __webpack_public_path__ + "static/comms@2x-684f38af0fae08b9bbd47f6e40210c65.png";